/**
 * @generated SignedSource<<269c3f40d51074f34b61394a6b402407>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "concreteType": "UserHomeAddress",
        "kind": "LinkedField",
        "name": "homeAddress",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "careOf",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
            },
            (v2 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postOfficeBox",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
            }
        ],
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UserHomeAddressUpdateModal_setUserHomeAddressMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SetUserHomeAddressPayload",
                    "kind": "LinkedField",
                    "name": "setUserHomeAddress",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UserHomeAddressUpdateModal_setUserHomeAddressMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SetUserHomeAddressPayload",
                    "kind": "LinkedField",
                    "name": "setUserHomeAddress",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "a8b6712fa96b1dd80c4fb18fa2be5a31",
            "id": null,
            "metadata": {},
            "name": "UserHomeAddressUpdateModal_setUserHomeAddressMutation",
            "operationKind": "mutation",
            "text": "mutation UserHomeAddressUpdateModal_setUserHomeAddressMutation(\n  $model: SetUserHomeAddressInput!\n) {\n  setUserHomeAddress(model: $model) {\n    user {\n      homeAddress {\n        careOf\n        city\n        id\n        postOfficeBox\n        postalCode\n        street\n      }\n      id\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "b5d12c81878db510b4af6168dfe3155e";
export default node;
